import { render } from "./AdminTopUser.vue?vue&type=template&id=6ed5753f&scoped=true"
import script from "./AdminTopUser.vue?vue&type=script&lang=js"
export * from "./AdminTopUser.vue?vue&type=script&lang=js"

import "./AdminTopUser.vue?vue&type=style&index=0&id=6ed5753f&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed5753f"]])

export default __exports__